export default __webpack_public_path__ + "static/media/maven-setup.fdb634d0.md";